import React from 'react';

import { palettes, EllipsisLoader } from '@indigo-ag/component-module';
import { branch, renderComponent } from 'recompose';

export interface ReleventApolloProps {
  data: {
    loading: boolean;
  };
}

const Loader = () => (
  <EllipsisLoader
    style={{
      alignItems: 'center',
      color: palettes.brand.blue.base,
      display: 'flex',
      flex: 1,
      fontSize: '2rem',
      justifyContent: 'center',
      margin: '2rem'
    }}
  />
);

// TODO: replace this with the Loading Wrapper Component using hooks - graphql
export const WithLoading = branch((props: ReleventApolloProps) => {
  return props.data.loading;
}, renderComponent(Loader));
